import Notes from 'assets/icons/notes.svg';
import People from 'assets/icons/people.svg';
import Architer from 'assets/icons/architer.svg';
import Adding from 'assets/icons/adding.svg';

const titleProps = { fontSize: { desktop: '32px', tablet: '24px', mobile: '18px' } };
const contentProps = { justifyContent: 'center' };

export const consultingTechExpertData = {
  title: 'Наши услуги',

  cardsData: [
    {
      title: 'Анализ бизнес-процессов',
      titleProps,
      tabIcon: Notes,
      content:
        'Одна из самых важных процедур, которые необходимо проводить регулярно. Специалисты анализируют бизнес-процессы и предлагают, как их оптимизировать.',
      contentProps,
    },
    {
      title: 'Оценка персонала',
      titleProps,
      tabIcon: People,
      content:
        'Современный инструмент наблюдения. Он позволяет выявить проблемы, связанные с сотрудниками компании, и найти пути их решения.',

      contentProps,
    },
    {
      title: 'Рыночный аудит',
      titleProps,
      tabIcon: Architer,
      content:
        'Анализ плана продвижения компании от команды ASTON. Цель — оценить положение компании на рынке и предложить способ его усиления.',
      contentProps,
    },
    {
      title: 'Технический аудит',
      titleProps,
      tabIcon: Adding,
      content:
        'Всесторонняя проверка корпоративной сети. По итогам специалисты ASTON выдают заключение о качестве работы ИТ‑инфраструктуры и советы по исправлению проблем.',
      contentProps,
    },
  ],
};
